import type { PartialMessages } from "../messages";

export const th: PartialMessages = {
  "status.syncing": "ซิงก์แล้ว", "status.connecting": "กำลังเชื่อมต่อ", "status.full": "เต็ม", "status.closed": "หลุดการเชื่อมต่อ",
  "toast.connecting": "กำลังเชื่อมต่อ…", "toast.reconnecting": "การเชื่อมต่อหลุด กำลังต่อใหม่…",
  "toast.retrying": "อีกสักครู่จะลองใหม่", "toast.busy": "ตอนนี้คนใช้เยอะ",
  "notice.mapChanged": "{name} เปลี่ยนแผนที่",
  "hint.place": "คลิกเพื่อวาง ลากเพื่อกำหนดทิศทาง (Esc เพื่อยกเลิก)",
  "kind.objective": "จุดหมาย", "kind.rally": "จุดรวมพล", "kind.enemy": "ศัตรู", "kind.loot": "ของ",
  "kind.extract": "จุดออก", "kind.danger": "อันตราย", "kind.self": "ฉัน", "kind.ping": "ตรงนี้!",
  "hint.objective": "จะไปทางไหน", "hint.rally": "จุดนัดรวมพล",
  "hint.enemy": "หันไปทางที่เห็นศัตรู", "hint.loot": "กล่องหายาก ศพ",
  "hint.extract": "จุดออกที่วางแผนไว้", "hint.danger": "กับระเบิด สไนเปอร์ ที่โล่ง",
  "hint.self": "ตำแหน่งของคุณ วางใหม่แล้วอันเก่าจะหายไป",
  "hint.ping": "หมุดชั่วคราว หายไปเองใน 25 วินาที",
  "tool.clearMine": "ลบของฉัน", "tool.clearMineHint": "ลบหมุดทั้งหมดที่คุณวางไว้",
  "sidebar.map": "แผนที่ (มีผลกับทุกคน)", "sidebar.styleSvg": "ภาพวาด", "sidebar.styleTile": "ภาพถ่ายดาวเทียม",
  "sidebar.floors": "ชั้น (เปลี่ยนเฉพาะมุมมองของคุณ)", "sidebar.groundFloor": "ชั้นล่าง",
  "sidebar.floorNote": "หมุดที่อยู่ชั้นอื่นจะแสดงจาง ๆ",
  "sidebar.members": "{count} คน", "sidebar.you": "คุณ", "sidebar.guest": "แขก",
  "sidebar.clearAll": "ลบหมุดทั้งหมด", "sidebar.openWindow": "เปิดในหน้าต่างแยก (เฉพาะฉัน)",
  "sidebar.invite": "เชิญคนอื่น", "sidebar.help": "วิธีใช้", "sidebar.feedback": "ส่งความเห็น",
  "sidebar.mapData": "ข้อมูลแผนที่", "sidebar.license": "สัญญาอนุญาต", "sidebar.licenseNote": "ใช้เพื่อการไม่แสวงหากำไรเท่านั้น",
  "sidebar.room": "ห้อง",
  "pin.facing": "ทิศทาง", "pin.floor": "ชั้น", "pin.map": "แผนที่", "pin.noFacing": "ไม่มีทิศทาง",
  "pin.facingValue": "{compass} ({degrees}°)",
  "pin.notePlaceholder": "เขียนโน้ต (เช่น หน้าต่างชั้นสาม)",
  "pin.removeMine": "ลบหมุดนี้", "pin.removeOther": "ลบหมุดของคนอื่น", "pin.close": "ปิด",
  "compass.n": "เหนือ", "compass.ne": "ตะวันออกเฉียงเหนือ", "compass.e": "ตะวันออก", "compass.se": "ตะวันออกเฉียงใต้",
  "compass.s": "ใต้", "compass.sw": "ตะวันตกเฉียงใต้", "compass.w": "ตะวันตก", "compass.nw": "ตะวันตกเฉียงเหนือ",
  "handoff.title": "เปิดในหน้าต่างแยก",
  "handoff.lede": "ลิงก์สำหรับตัวคุณเอง เปิดห้องเดียวกันในเบราว์เซอร์ เพื่อให้ Discord แสดงการแชร์หน้าจอต่อไป ส่วนแผนที่อยู่บนอีกจอ",
  "handoff.open": "เปิดในเบราว์เซอร์ของเครื่องนี้", "handoff.or": "ถ้าจะเปิดบนอุปกรณ์อื่น",
  "handoff.codeHint": "บนอุปกรณ์นั้น เข้า {host}/j/ แล้วใส่รหัสด้านบน",
  "handoff.copy": "คัดลอกลิงก์", "handoff.copied": "คัดลอกแล้ว",
  "handoff.copyFailed": "เลือกข้อความด้านบนแล้ว — กด Ctrl+C",
  "handoff.expiry": "ลิงก์นี้ใช้ได้ครั้งเดียว หมดอายุใน {time}",
  "handoff.warn": "ส่งต่อให้คนอื่นไม่ได้ (เปิดแล้วถือว่าใช้ไป) ถ้าจะเรียกคนให้ใช้ «เชิญคนอื่น»",
  "handoff.creating": "กำลังสร้างลิงก์…", "handoff.failed": "สร้างลิงก์ไม่สำเร็จ",
  "invite.title": "เชิญคนอื่น",
  "invite.lede": "เรียกคนที่ไม่ได้อยู่ในห้องเสียงเข้ามาดูแผนที่ได้ เขาจะใส่ชื่อแล้ววางหมุดได้เลย",
  "invite.copy": "คัดลอกลิงก์", "invite.warn": "ใครที่รู้ลิงก์นี้ก็เข้าร่วมได้ อย่าโพสต์ในที่สาธารณะ",
  "invite.budget": "เข้าได้อีก {left} คน หมดอายุใน {time} (ใช้ไป {used}/{max})",
  "invite.revoke": "ยกเลิกลิงก์นี้ทันที", "invite.revoked": "ยกเลิกลิงก์แล้ว",
  "invite.creating": "กำลังสร้างลิงก์…", "invite.failed": "สร้างลิงก์ไม่สำเร็จ",
  "invite.revokeFailed": "ยกเลิกไม่สำเร็จ",
  "join.title": "เข้าร่วมแผนที่",
  "join.lede": "คุณถูกเชิญเข้าแผนที่ของเรด เลือกชื่อที่จะแสดง ชื่อนี้จะปรากฏบนหมุดที่คุณวาง",
  "join.name": "ชื่อ", "join.go": "เข้าร่วม", "join.joining": "กำลังเข้าร่วม…", "join.failed": "เข้าร่วมไม่สำเร็จ",
  "feedback.title": "ส่งถึงผู้พัฒนา", "feedback.request": "ข้อเสนอ", "feedback.bug": "ปัญหา",
  "feedback.other": "อื่น ๆ", "feedback.requestHint": "อยากให้เป็นแบบนี้",
  "feedback.bugHint": "มีบางอย่างผิดปกติ", "feedback.otherHint": "อะไรก็ได้",
  "feedback.placeholder": "เช่น อยากลากเส้นได้ ไม่ใช่แค่ลูกศร / ที่ Streets สลับชั้นไม่ได้",
  "feedback.note": "ชื่อที่แสดงใน Discord และ ID จะถูกส่งไปด้วย เผื่อต้องตอบกลับ",
  "feedback.send": "ส่ง", "feedback.sending": "กำลังส่ง…", "feedback.sent": "ส่งแล้ว ขอบคุณครับ",
  "feedback.failed": "ส่งไม่สำเร็จ",
  "time.minutes": "{n} นาที", "time.hoursMinutes": "{h} ชม. {m} นาที",
  "error.roomFull": "ห้องนี้เต็มแล้ว",
  "error.tooManyWindows": "เปิดห้องนี้ไว้หลายหน้าต่างเกินไป ปิดสักอันก่อน",
  "error.serverFull": "เซิร์ฟเวอร์เต็ม", "error.session": "เซสชันหมดอายุ กรุณาเปิดใหม่",
  "error.handoffSpent": "ลิงก์นี้ใช้ไม่ได้ เป็นลิงก์เฉพาะตัวและใช้ได้ครั้งเดียว ถ้าจะเรียกคนอื่น ให้สร้างลิงก์เชิญจากแผนที่",
  "error.inviteSpent": "ลิงก์เชิญนี้ใช้ไม่ได้แล้ว ขอลิงก์ใหม่จากคนในห้อง",
  "error.inviteNotOwner": "เฉพาะคนที่สร้างลิงก์เท่านั้นที่ยกเลิกได้",
  "error.noRoom": "ไม่ได้ระบุห้อง", "error.needName": "กรุณาใส่ชื่อ",
  "error.tooShort": "เขียนเพิ่มอีกนิดนะ", "error.tooLong": "ยาวเกินไป",
  "error.badKind": "ประเภทไม่ถูกต้อง",
  "error.rateLimited": "ส่งถี่เกินไป รออีกสัก 10 นาที",
  "error.busy": "ตอนนี้คนใช้เยอะ ลองใหม่อีกสักครู่",
  "error.sendFailed": "ส่งไม่สำเร็จ ลองใหม่ภายหลัง",
  "error.feedbackClosed": "ตอนนี้ปิดรับความเห็นชั่วคราว",
  "error.sessionGone": "เซสชันเดิมจบไปแล้ว เปิดจากกิจกรรมใหม่อีกครั้ง",
  "landing.tagline1": "แชร์แผนที่ Tarkov",
  "landing.tagline2": "ให้ทุกคนในห้องเสียง Discord ดูพร้อมกันแล้วอธิบายไปด้วย",
  "landing.install": "เพิ่มลง Discord",
  "landing.installNote": "ฟรี เปิดจากไอคอนจรวดในห้องเสียง",
  "landing.body": "ทุกคนในสายเห็นแผนที่เดียวกัน คลิกเพื่อวางหมุด และถ้าลากตอนวางจะได้ลูกศรบอกทิศทางด้วย จึงบอกได้ทั้ง «ตรงไหน» และ «ไปทางไหน»",
  "landing.point1": "แค่อยู่ในสายเดียวกันก็เข้าแผนที่เดียวกัน ไม่ต้องพิมพ์รหัส",
  "landing.point2": "ครบทั้ง 13 แผนที่ สลับภาพวาดกับภาพดาวเทียม และเปลี่ยนชั้นได้",
  "landing.point3": "หมุดที่วางไว้ยังอยู่ กลับมาดูทีหลังได้",
  "landing.point4": "คนที่ไม่ได้อยู่ในสายก็เข้าได้ด้วยลิงก์เชิญ",
  "landing.footNote": "ไม่ยุ่งกับตัวเกมเลย ไม่อ่านไฟล์ ไม่อ่านหน่วยความจำ ไม่วาดอะไรทับหน้าจอเกม ทุกหมุดคนวางเองทั้งนั้น",
  "landing.footCredit": "งานอดิเรกของคนคนเดียว เปิดให้ใช้ฟรี ข้อมูลแผนที่จาก {tarkovdev} (CC BY-NC-SA 4.0) Escape from Tarkov เป็นผลิตภัณฑ์ของ Battlestate Games Limited โปรเจกต์นี้เป็นงานแฟนเมดที่ไม่เกี่ยวข้องกับบริษัท",
  "landing.updates": "อัปเดต", "landing.allUpdates": "อัปเดตทั้งหมด",
  "boot.connecting": "กำลังเชื่อมต่อกับ Discord…", "boot.failedTitle": "เริ่มไม่สำเร็จ",
};
